module.exports = __webpack_public_path__ + "img/8b8f26800c89fcbf8b97e4dde643312e.10f85a87.png";